<template>
  <v-card flat>
    <v-card-text>
      <v-expansion-panels accordion>
        <v-expansion-panel>
          <v-expansion-panel-header><b>Filters</b></v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-autocomplete
              v-model="map_id"
              :items="mapIds"
              :hint="createdAtHint"
              label="Map ID"
              background-color="grey lighten-1"
              class="pt-1"
              clearable
              dense
              solo
              flat
              persistent-hint
              item-text="mapId"
              item-value="mapId"
              hide-detailse="auto"
            />
            <v-autocomplete
              v-model="revision"
              :items="revisions"
              :loading="loadingRevisions"
              label="Revision"
              background-color="grey lighten-2"
              class="pt-1"
              clearable
              dense
              solo
              flat
              persistent-hint
              item-text="name"
              item-value="name"
              hide-detailse="auto"
            />
            <v-autocomplete
              v-model="selectedLevels"
              :items="levels"
              :loading="loadingLevels"
              label="Levels"
              background-color="grey lighten-4"
              hide-details="auto"
              multiple
              chips
              small-chips
              dense
              solo
              flat
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <levelsStatsticTables />
    </v-card-text>
  </v-card>
</template>

<script>
import levelsStatsticTables from '../components/levels-statstic-tables/levelsStatsticTables.vue';
export default {
  components: {
    levelsStatsticTables
  },
  data () {
    let selectedLevels = this.$route.query.levels || []

    if (!Array.isArray(selectedLevels)) {
      selectedLevels = [selectedLevels]
    }

    return {
      loadingRevisions: false,
      loadingLevels: false,
      mapIds: [],
      revisions: [],
      map_id: this.$route.query.map_id || null,
      revision: this.$route.query.revision || null,
      selectedLevels: selectedLevels,
      levels: []
    }
  },
  async mounted () {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/multi-map')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.mapIds = data
      if (this.$route.query.map_id) {
        this.map_id = this.$route.query.map_id
      } else if (data.length) {
        this.map_id = data[0].mapId
      }

      await Promise.all([
        this.getLevels(),
        this.getRevisions()
      ])
    }
  },
  watch: {
    async map_id (val) {
      if (val) {
        this.selectedLevels = []
        await Promise.all([
          this.getLevels(),
          this.getRevisions()
        ])
      }
    },
    selectedLevels () {
      this.updateRouterQuery()
    },
    revision () {
      this.updateRouterQuery()
    }
  },
  computed: {
    createdAtHint () {
      const val = this.mapIds.find(mapId => mapId.mapId === this.map_id)
      if (val) {
        return val.createdAt
      } else {
        return ''
      }
    }
  },
  methods: {
    async getRevisions () {
      this.loadingRevisions = true
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/map/revisions', {
        params: {
          map_id: this.map_id
        }
      })

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.revisions = data
        if (this.$route.query.revision) {
          this.revision = this.$route.query.revision
        } else if (data.length) {
          this.revision = data[0].name
        }
      }
      this.loadingRevisions = false
    },
    async getLevels () {
      this.loadingLevels = true
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/multi-map/' + this.map_id)
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const nonUniquelevels = data.map(level => level.name)
        this.levels = [...new Set(nonUniquelevels)].sort((a, b) => {
          if (a.toLowerCase() > b.toLowerCase()) return 1
          if (a.toLowerCase() < b.toLowerCase()) return -1
          return 0
        })
      }
      this.loadingLevels = false
    },
    updateRouterQuery () {
      this.$router.replace({
        path: "/levels-statistic",
        query: {
          map_id: this.map_id,
          revision: this.revision,
          levels: this.selectedLevels
        }
      })
    }
  }
}
</script>